import React from 'react';
import { App } from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';
import 'vfpf.prototype';
import { createRoot } from 'react-dom/client';

const getUserConfirmation = (message: any, callback: (arg0: boolean) => void) => {
  callback(false);
};

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <Router basename={'/ssa'} getUserConfirmation={getUserConfirmation}>
      <CompatRouter>
        <App />
      </CompatRouter>
    </Router>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
